const language = {
	spanish: {
		header_title: "My ",
		header_span_title: "Tracker",
		tracker_red_title: "MY TRACKER",
		tracker_bold_title:
			"Foresight GPS cuenta con seguimiento profesional y monitoreo para personal VIP y/o familiares en tiempo real con un dispositivo que se puede llevar en cualquier parte.",
		tracker_bold_text:
			"Nuestra plataforma de G-Evolution garantiza la protección de todos los vehículos, personal y otros activos importantes.",
		tracker_text: [
			"Basados en una plataforma única que combina una variedad de tecnologías establecidas desde GPS y comunicación inalámbrica hasta mapeo digital y aplicaciones móviles.",
			"Foresight GPS ofrece la creación y gestión de áreas de seguridad digitales sobre mapas digitales, la cual permite a los usuarios establecer eventos para el seguimiento profesional de personas y activos.",
			"Esta característica ofrece a las familias y a los usuarios empresariales una seguridad mejorada, una amplia visibilidad y una comodidad adicional.",
		],
		beneficios_red_title: "BENEFICIOS",
		beneficio_1:
			"Creación de áreas de seguridad y alertas de entrada y salida de estas áreas.",
		beneficio_2:
			"Alertas de seguridad desde en dispositivos discretos o vía aplicación móvil.",
		beneficio_3: "Rastreo en tiempo real de personas sobre mapas digitales.",
		beneficio_4: "Desarrollo marca blanca dependiendo de las necesidades.",
		beneficio_5:
			"Lleve el control de su activo desde una aplicación móvil o la web.",
		beneficio_6: "Soporte de servicio 24/7.",
		beneficio_7_bold_title: "Previene pérdida de activos",
		beneficio_7_text:
			"En tiempo real con visibilidad remota y recepción de alertas, podrás saber si tu activo es movido del lugar sin autorización.",
		beneficio_8_bold_title: "Localización de personas y objetos",
		beneficio_8_text:
			"Con un pequeño dispositivo y una plataforma de última generación, puedes visualizar sobre mapas digitalizados y fotos satelitales la localización de tus hijos o seres queridos en tiempo real.",
		caracteristicas_red_title: "CARACTERÍSTICAS",
		caracteristicas_bold_text:
			"Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		caracteristicas_list: [
			"Historial de recorridos por cada persona",
			"Sistema de localización GPS y vía aplicación móvil",
			"Alertas en tiempo real, si el dispositivo sale o entra de un área predeterminada",
			"Batería de larga duración con autonomía mayor a 4 días (para dispositivos independientes)",
			"Botón de pánico (SOS) que lanza una alerta al teléfono particular asociado o un SOS desde una aplicación móvil",
			"Dispositivos versátil y pequeños",
			"No requiere instalación",
		],
		form_title: "Deseamos ayudarte, contáctanos ahora:",
		form_button_content: "ENVÍA TU RESUMEN",
		form_fields: [
			{
				title: "Nombre y Apellido",
				requestKey: "nombre_apellido",
			},
			{
				title: "Email",
				requestKey: "email",
			},
			{
				title: "País",
				requestKey: "pais",
			},
			{
				title: "Apellido",
				requestKey: "apellido",
			},
			{
				title: "Móvil",
				requestKey: "movil",
			},
			{
				title: "Empresa",
				requestKey: "empresa",
				type: "text",
			},
			{
				title: "Asunto",
				requestKey: "asunto",
			},
		],
	},
	english: {
		header_title: "My ",
		header_span_title: "Tracker",
		tracker_red_title: "MY TRACKER",
		tracker_bold_title:
			"ForesightGPS works with professional tracking in real life for VIP staff and/or family members with a device that can be carried everywhere.",
		tracker_bold_text:
			"Our G-Evolution platform guarantees the protection of all vehicles, personnel, and other important assets.",
		tracker_text: [
			"Based on a single platform that takes advantage of a variety of well-established technologies, from GPS and wireless communication to digital mapping and mobile apps.",
			"We offer the creation and management of security areas on digital maps. This allows users to set events for the professional tracking of people and assets.",
			"This feature also offers families and business users enhanced security, broad visibility, and additional convenience.",
		],
		beneficios_red_title: "BENEFITS",
		beneficio_1: "Creation of security areas with alerts of entry and exit.",
		beneficio_2: "Security alerts from discrete devices or mobile app.",
		beneficio_3: "Real time tracking on digital maps.",
		beneficio_4: "White label development depending on needs.",
		beneficio_5: "Take control of your assets from the mobile app or web.",
		beneficio_6: "24/7 service support.",
		beneficio_7_bold_title: "Prevents loss of assets",
		beneficio_7_text:
			"In real time with remote visibility and alerts, you will be able to know if your asset is moved from the site without authorization.",
		beneficio_8_bold_title: "Location of people and assets",
		beneficio_8_text:
			"With a small device and last generation platform, you can visualize on digital maps or satellite photos the location of your loved ones or assets in real time.",
		caracteristicas_red_title: "FEATURES",
		caracteristicas_bold_text:
			"We have the best technological innovation for optimal tracking of your mobile assets:",
		caracteristicas_list: [
			"Movement history for each person.",
			"GPS location system via mobile app.",
			"Real time alerts if the device enters a predetermined area.",
			"Long-lasting battery of +4 days for independent devices.",
			"Panic button (SOS) from device or app that alerts the associated phone.",
			"Versatile and small devices.",
			"No installation required.",
		],
		form_title: "We want to help you, contact us now:",
		form_button_content: "SEND YOUR SUMMARY",
		form_fields: [
			{
				title: "First Name",
				requestKey: "nombre_apellido",
			},
			{
				title: "Email",
				requestKey: "email",
			},
			{
				title: "Country",
				requestKey: "pais",
			},
			{
				title: "Last Name",
				requestKey: "apellido",
			},
			{
				title: "Mobile",
				requestKey: "movil",
			},
			{
				title: "Company",
				requestKey: "empresa",
				type: "text",
			},
			{
				title: "Subject",
				requestKey: "asunto",
			},
		],
	},
};

export default language;